module.exports = __webpack_public_path__ + "img/gh-12205-8.prt.1780d4a0.jpg";